import React from 'react';
// import { useNavigate } from 'react-router-dom';

const SubmitPage = () => {
    // const navigate = useNavigate();

    return (
        <div>
            <h1>Your print has been submitted.</h1>
        </div>
    )
}

export default SubmitPage;